<template>
    <div>
        <!-- DIALOG DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: .5em" />
            <div
                class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                {{ loadingMensaje }}</div>
        </Dialog>
        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Otro Pago</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-save" class="p-button-rounded p-button-success p-button-outlined" @click="PostOtroPago()" />
                </div>
            </div>
            <hr size=7 color="#ED6421">
        </div>
        <br>
        <div class="card">
            <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                <!-- CLAVE SAT -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="otroPago.tipoOtroPago" :options="tipoOtroPago" optionLabel="tipoOtroPago" @change="muestraSugerencia"/>
                        <label>Tipo de Percepción</label>
                    </span>
                </div>
                <!-- CLAVE -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <InputText v-model="otroPago.clave" type="text" />
                        <label>Clave</label>
                    </span>
                </div>
                <!-- CONCEPTO -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <InputText v-model="otroPago.concepto" type="text" />
                        <label>Concepto</label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        components: {

        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            otroPago(){
                return this.$store.state.otroPagoStore;
            },
            tipoOtroPago(){
                return this.$store.state.tipoOtroPagoStore
            },
        },
        created() {
            
        },
        methods: {
            async PostOtroPago(){
                try{
                    this.loading = true;
                    this.loadingMensaje = 'Guardando concepto...'
                    let ObjOtroPago = {}
                    ObjOtroPago = { ...this.otroPago };
                    let respuesta = await axios.post("Nomina/PostOtroPago/" + this.token.empresaBase, ObjOtroPago);
                    let x =  respuesta.data;
                    ObjOtroPago.id = x;
                    this.$store.state.otrosPagosStore.push(ObjOtroPago);
                    this.cierraVentana();
                }catch(error){
                    this.loading = false;
                    console.log(error);
                }
            },

            cierraVentana(){
                this.$emit('closeDialogOtroPago')
            },

            muestraSugerencia(){
                this.otroPago.clave = this.otroPago.tipoOtroPago.clave;
                this.otroPago.concepto = this.otroPago.tipoOtroPago.descripcion;
            },
        },
    }
    </script>
    <style>
    </style>